

// import React, { useState } from 'react';
// import { useAuth } from '../App';
// import { Link, useNavigate } from 'react-router-dom';
// import { Button } from '../components/ui/button';
// import { Input } from '../components/ui/input';
// import { Label } from '../components/ui/label';
// import {
//   Card,
//   CardContent,
//   CardDescription,
//   CardHeader,
//   CardTitle,
// } from '../components/ui/card';
// import { toast } from 'sonner';
// import { Mail, Lock, LogIn } from 'lucide-react';

// export default function Login() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [loading, setLoading] = useState(false);

//   const { login, axiosInstance } = useAuth();
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const response = await axiosInstance.post('/auth/login', {
//         email,
//         password,
//       });

//       // const response = await axiosInstance.post('/api/auth/login', {
//       //   email,
//       //   password,
//       // });

//       login(response.data.token, response.data.user);

//       toast.success('Connexion réussie !');

//       // Redirection selon le rôle
//       const role = response.data.user.role;

//       if (role === 'institution') {
//         navigate('/institution-dashboard');
//       } else {
//         navigate('/dashboard');
//       }
//     } catch (error) {
//       const message =
//         error.response?.data?.detail || 'Échec de la connexion';

//       toast.error(message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div
//       className="min-h-screen flex items-center justify-center p-4"
//       style={{
//         background:
//           'linear-gradient(135deg, #F5FAFA 0%, #D4EBEB 50%, #EEF7F7 100%)',
//       }}
//     >
//       <div className="w-full max-w-md">

//         {/* Logo / Header */}
//         <div className="text-center mb-8 fade-in">
//           <h1
//             className="text-5xl font-bold mb-2"
//             style={{
//               fontFamily: 'Playfair Display, serif',
//               color: '#356B6B',
//             }}
//           >
//             Sana-Care
//           </h1>

//           <p
//             className="text-lg font-medium"
//             style={{ color: '#5A8F8F' }}
//           >
//             Infi As Pro
//           </p>
//         </div>

//         {/* Carte de connexion */}
//         <Card
//           className="bg-white/95 backdrop-blur-sm shadow-xl"
//           style={{
//             borderColor: '#C5DFDF',
//           }}
//           data-testid="login-card"
//         >
//           <CardHeader>
//             <CardTitle
//               className="text-2xl text-center"
//               style={{ color: '#356B6B' }}
//             >
//               <LogIn
//                 className="inline mr-2 mb-1"
//                 size={28}
//                 style={{ color: '#5A8F8F' }}
//               />
//               Connexion
//             </CardTitle>

//             <CardDescription className="text-center text-gray-500">
//               Connectez-vous à votre compte professionnel
//             </CardDescription>
//           </CardHeader>

//           <CardContent>
//             <form onSubmit={handleSubmit} className="space-y-4">

//               {/* Email */}
//               <div className="space-y-2">
//                 <Label
//                   htmlFor="email"
//                   className="font-medium"
//                   style={{ color: '#356B6B' }}
//                 >
//                   Email
//                 </Label>

//                 <div className="relative">
//                   <Mail
//                     className="absolute left-3 top-3"
//                     size={20}
//                     style={{ color: '#5A8F8F' }}
//                   />

//                   <Input
//                     id="email"
//                     type="email"
//                     placeholder="votre.email@example.com"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     required
//                     className="pl-10 bg-white"
//                     style={{
//                       borderColor: '#C5DFDF',
//                     }}
//                     data-testid="login-email-input"
//                   />
//                 </div>
//               </div>

//               {/* Mot de passe */}
//               <div className="space-y-2">
//                 <Label
//                   htmlFor="password"
//                   className="font-medium"
//                   style={{ color: '#356B6B' }}
//                 >
//                   Mot de passe
//                 </Label>

//                 <div className="relative">
//                   <Lock
//                     className="absolute left-3 top-3"
//                     size={20}
//                     style={{ color: '#5A8F8F' }}
//                   />

//                   <Input
//                     id="password"
//                     type="password"
//                     placeholder="••••••••"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     required
//                     className="pl-10 bg-white"
//                     style={{
//                       borderColor: '#C5DFDF',
//                     }}
//                     data-testid="login-password-input"
//                   />
//                 </div>
//               </div>

//               {/* Mot de passe oublié */}
//               <div className="mt-4 text-center">
//                 <Link
//                   to="/forgot-password"
//                   className="font-semibold transition-colors"
//                   style={{ color: '#356B6B' }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.color = '#5A8F8F';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.color = '#356B6B';
//                   }}
//                   data-testid="forgot-password-link"
//                 >
//                   Mot de passe oublié ?
//                 </Link>
//               </div>

//               {/* Bouton connexion */}
//               <Button
//                 type="submit"
//                 className="w-full text-lg py-6 text-white shadow-md transition-all"
//                 style={{
//                   backgroundColor: '#5A8F8F',
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.backgroundColor = '#356B6B';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.backgroundColor = '#5A8F8F';
//                 }}
//                 disabled={loading}
//                 data-testid="login-submit-button"
//               >
//                 {loading ? 'Connexion...' : 'Se connecter'}
//               </Button>
//             </form>

//             {/* Inscription */}
//             <div className="mt-6 text-center">
//               <p className="text-sm text-gray-500">
//                 Pas encore de compte ?{' '}

//                 <Link
//                   to="/register"
//                   className="font-semibold transition-colors"
//                   style={{ color: '#356B6B' }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.color = '#5A8F8F';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.color = '#356B6B';
//                   }}
//                   data-testid="register-link"
//                 >
//                   S'inscrire
//                 </Link>
//               </p>
//             </div>
//           </CardContent>
//         </Card>

//         {/* Footer */}
//         <div className="text-center mt-6">
//           <p
//             className="text-xs"
//             style={{ color: '#7A9B9B' }}
//           >
//             Sana-Care • Infi As Pro
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }




import React, { useState } from 'react';
import { useAuth } from '../App';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../components/ui/card';
import { toast } from 'sonner';
import { Mail, Lock, LogIn } from 'lucide-react';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const { login, axiosInstance } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axiosInstance.post('/auth/login', {
        email,
        password,
      });

      login(response.data.token, response.data.user);

      toast.success('Connexion réussie !');

      // const role = response.data.user.role;

      // if (role === 'institution') {
      //   navigate('/institution-dashboard');
      // } else if (role === 'titulaire_domicile') {
      //   navigate('/titulaire-dashboard');
      // } else {
      //   navigate('/dashboard');
      // }

      const role = response.data.user.role;

      if (role === 'institution') {
        navigate('/institution-dashboard');
      } else if (role === 'titulaire_domicile') {
        navigate('/titulaire-dashboard');
      } else {
        navigate('/dashboard');
      }
    } catch (error) {
      const message =
        error.response?.data?.detail || 'Échec de la connexion';

      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        background:
          'linear-gradient(135deg, #F5FAFA 0%, #D4EBEB 50%, #EEF7F7 100%)',
      }}
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-8 fade-in">
          <h1
            className="text-5xl font-bold mb-2"
            style={{
              fontFamily: 'Playfair Display, serif',
              color: '#356B6B',
            }}
          >
            Sana-Care
          </h1>

          <p
            className="text-lg font-medium"
            style={{ color: '#5A8F8F' }}
          >
            Infi As Pro
          </p>
        </div>

        <Card
          className="bg-white/95 backdrop-blur-sm shadow-xl"
          style={{ borderColor: '#C5DFDF' }}
          data-testid="login-card"
        >
          <CardHeader>
            <CardTitle
              className="text-2xl text-center"
              style={{ color: '#356B6B' }}
            >
              <LogIn
                className="inline mr-2 mb-1"
                size={28}
                style={{ color: '#5A8F8F' }}
              />
              Connexion
            </CardTitle>

            <CardDescription className="text-center text-gray-500">
              Connectez-vous à votre compte professionnel
            </CardDescription>
          </CardHeader>

          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label
                  htmlFor="email"
                  className="font-medium"
                  style={{ color: '#356B6B' }}
                >
                  Email
                </Label>

                <div className="relative">
                  <Mail
                    className="absolute left-3 top-3"
                    size={20}
                    style={{ color: '#5A8F8F' }}
                  />

                  <Input
                    id="email"
                    type="email"
                    placeholder="votre.email@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="pl-10 bg-white"
                    style={{ borderColor: '#C5DFDF' }}
                    data-testid="login-email-input"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <Label
                  htmlFor="password"
                  className="font-medium"
                  style={{ color: '#356B6B' }}
                >
                  Mot de passe
                </Label>

                <div className="relative">
                  <Lock
                    className="absolute left-3 top-3"
                    size={20}
                    style={{ color: '#5A8F8F' }}
                  />

                  <Input
                    id="password"
                    type="password"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className="pl-10 bg-white"
                    style={{ borderColor: '#C5DFDF' }}
                    data-testid="login-password-input"
                  />
                </div>
              </div>

              <div className="mt-4 text-center">
                <Link
                  to="/forgot-password"
                  className="font-semibold transition-colors"
                  style={{ color: '#356B6B' }}
                  data-testid="forgot-password-link"
                >
                  Mot de passe oublié ?
                </Link>
              </div>

              <Button
                type="submit"
                className="w-full text-lg py-6 text-white shadow-md transition-all"
                style={{ backgroundColor: '#5A8F8F' }}
                disabled={loading}
                data-testid="login-submit-button"
              >
                {loading ? 'Connexion...' : 'Se connecter'}
              </Button>
            </form>

            <div className="mt-6 text-center">
              <p className="text-sm text-gray-500">
                Pas encore de compte ?{' '}
                <Link
                  to="/register"
                  className="font-semibold transition-colors"
                  style={{ color: '#356B6B' }}
                  data-testid="register-link"
                >
                  S'inscrire
                </Link>
              </p>
            </div>
          </CardContent>
        </Card>

        <div className="text-center mt-6">
          <p className="text-xs" style={{ color: '#7A9B9B' }}>
            Sana-Care • Infi As Pro
          </p>
        </div>
      </div>
    </div>
  );
}
